// extracted by mini-css-extract-plugin
export default {"itinerary":"RenderedItinerary_itinerary__8vQoX","heading":"RenderedItinerary_heading__FpJ2F","days":"RenderedItinerary_days__3xbTr"};